import React from 'react';
import { Check } from '@mui/icons-material';
import ProviderLogo from './ProviderLogo';

/** Choix du réseau de paiement : logos ronds alignés sur une ligne, le réseau choisi est mis en avant. */
const ProviderPicker = ({ providers = [], selectedId, onSelect, loading = false }) => {
    if (loading) {
        return (
            <div className="flex justify-center py-6">
                <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (providers.length === 0) {
        return <p className="text-sm text-slate-500 py-4">Aucun réseau disponible pour le moment.</p>;
    }

    return (
        <div className="flex items-center gap-3 sm:gap-4 overflow-x-auto py-2.5 px-2">
            {providers.map((provider) => {
                const selected = selectedId === provider.id;
                return (
                    <button
                        key={provider.id}
                        type="button"
                        onClick={() => onSelect(provider)}
                        title={provider.name}
                        aria-label={provider.name}
                        aria-pressed={selected}
                        className={`relative shrink-0 rounded-full transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 ${
                            selected
                                ? 'ring-[3px] ring-amber-500 ring-offset-2 scale-105 shadow-lg shadow-amber-500/30'
                                : 'ring-1 ring-slate-200 opacity-80 hover:opacity-100 hover:ring-amber-300 hover:scale-105'
                        }`}
                    >
                        <ProviderLogo provider={provider} className="w-12 h-12 sm:w-14 sm:h-14 rounded-full" />
                        {selected && (
                            <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-amber-500 text-white ring-2 ring-white">
                                <Check sx={{ fontSize: 14 }} />
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default ProviderPicker;
